import { render, staticRenderFns } from "./clxg.vue?vue&type=template&id=2563e294&scoped=true"
import script from "./clxg.vue?vue&type=script&lang=js"
export * from "./clxg.vue?vue&type=script&lang=js"
import style0 from "./clxg.vue?vue&type=style&index=0&id=2563e294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563e294",
  null
  
)

export default component.exports